import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Section, SectionHeader } from "../components/Section";
import { Card } from "../components/Card";
import { CTASection } from "../components/CTASection";
import { DOMAINS } from "../lib/domains";
import { Link } from "react-router-dom";
import { useTranslation } from "../lib/i18n";

export default function DomainsPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title="Domains — Sentinel"
        description="Twelve safety domains: Operational, Environmental, Fire, Mechanical, Electrical, Thermal, Digital, Chemical, Compliance & Governance, Radiation, Biological, and Structural."
        canonical="/domains"
        image="https://images.pexels.com/photos/270360/pexels-photo-270360.jpeg?auto=compress&cs=tinysrgb&w=1200"
      />
      <PageHero
        eyebrow={t("domains.page.eyebrow")}
        title={t("domains.page.title")}
        description={t("domains.page.description")}
        bgVariant="steel"
        bgImage="https://images.pexels.com/photos/270360/pexels-photo-270360.jpeg?auto=compress&cs=tinysrgb&w=1600"
      />

      <Section>
        <SectionHeader
          eyebrow={t("domains.list.eyebrow")}
          title={t("domains.list.title")}
        />
        <div className="grid grid-3">
          {[...DOMAINS].sort((a, b) => a.name.localeCompare(b.name)).map((domain) => (
            <Link key={domain.slug} to={`/domains/${domain.slug}`} style={{ textDecoration: "none" }}>
              <Card hover>
                <div
                  style={{
                    width: "100%",
                    height: "120px",
                    borderRadius: "var(--radius-md)",
                    backgroundImage: `url(${domain.backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    marginBottom: "1rem",
                    opacity: 0.8,
                  }}
                />
                <div style={{ display: "flex", alignItems: "center", gap: "0.625rem", marginBottom: "0.5rem" }}>
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "var(--radius-md)",
                      background: "var(--accent-50)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "var(--accent-600)",
                      fontWeight: 800,
                      fontSize: "1rem",
                    }}
                  >
                    {domain.name[0]}
                  </div>
                  <h3 style={{ fontSize: "1.0625rem" }}>{domain.name}</h3>
                </div>
                <p className="text-muted" style={{ fontSize: "0.875rem", marginBottom: "0.75rem" }}>
                  {domain.tagline}
                </p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "0.375rem" }}>
                  {domain.interventions.slice(0, 2).map((iv) => (
                    <span key={iv.title} className="badge badge-accent" style={{ fontSize: "0.75rem" }}>
                      {iv.title}
                    </span>
                  ))}
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </Section>

      <CTASection
        title={t("domains.cta.title")}
        description={t("domains.cta.description")}
        primaryLabel={t("cta.registerNow")}
        primaryTo="/register"
        secondaryLabel={t("cta.viewTraining")}
        secondaryTo="/training"
      />
    </>
  );
}
